import { convertSnakeCaseToReadableString } from "@jugl-web/utils";
import { customerFieldDescriptorsById } from "@jugl-web/domain-resources/customers/components/CustomerFormField/constants";
import { FormField } from "@jugl-web/rest-api/customer-form-field";
import { ClientDefaultItem } from "../types";

type NewDataFields = {
  visible?: boolean;
  pos?: number;
};

export type ClientDefaultsAction =
  | {
      type: "ADD_ITEM";
      payload: ClientDefaultItem;
    }
  | {
      type: "MODIFY_ITEM";
      payload: {
        id: string;
        newData: NewDataFields;
      };
    }
  | {
      type: "REMOVE_ITEM";
      payload: { id: string };
    }
  | {
      type: "REORDER_ITEMS";
      payload: ClientDefaultItem[];
    }
  | {
      type: "SET_ITEMS";
      payload: (FormField & { visible: boolean })[];
    };

export const clientDefaultsReducer = (
  state: ClientDefaultItem[],
  { type, payload }: ClientDefaultsAction
): ClientDefaultItem[] => {
  const handleAddItem = (item: ClientDefaultItem) => [...state, item];

  const handleModifyItem = (itemId: string, newData: NewDataFields) => {
    const newItemData: NewDataFields = {};

    if (newData.visible !== undefined) {
      newItemData.visible = newData.visible;
    }

    if (newData.pos !== undefined) {
      newItemData.pos = newData.pos;
    }

    return state.map((item) => {
      if (item.id === itemId) {
        return {
          ...item,
          ...newItemData,
        };
      }
      return item;
    });
  };

  const handleRemoveItem = (itemId: string) =>
    state.filter((item) => item.id !== itemId);

  const handleReorderItems = (items: ClientDefaultItem[]) => items;

  const handleSetItems = (
    fields: (FormField & { visible: boolean })[]
  ): ClientDefaultItem[] =>
    fields.map((field, index) => ({
      id: field.id,
      name: customerFieldDescriptorsById[field.name]
        ? customerFieldDescriptorsById[field.name]
        : convertSnakeCaseToReadableString(field.name),
      visible: field.visible,
      pos: field.pos ?? index,
      type: field.type,
    }));

  switch (type) {
    case "ADD_ITEM":
      return handleAddItem(payload);
    case "MODIFY_ITEM":
      return handleModifyItem(payload.id, payload.newData);
    case "REMOVE_ITEM":
      return handleRemoveItem(payload.id);
    case "REORDER_ITEMS":
      return handleReorderItems(payload);
    case "SET_ITEMS":
      return handleSetItems(payload);
    default:
      return state;
  }
};
